export function staffRole(user) {
  return String(user?.role || user?.adminRole || '').toLowerCase().trim();
}

export function isUnderwritingRole(user) {
  const role = staffRole(user);
  return role === 'underwriting' || role === 'underwriter';
}

export function isFinanceDashboardRole(user) {
  const role = staffRole(user);
  return role === 'super_admin' || role === 'finance_admin';
}

export function isCreditControlRole(user) {
  return staffRole(user) === 'credit_control';
}
